import React, { useEffect, useRef, useState } from 'react';
import { Html5Qrcode } from 'html5-qrcode';
import { X, Camera } from 'lucide-react';

export default function QrScanner({ onScan, onClose, onTicketScan }) {
  const [error, setError] = useState(null);
  const scannerRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    let html5Qr = null;
    const startScanner = async () => {
      try {
        html5Qr = new Html5Qrcode("qr-reader");
        scannerRef.current = html5Qr;
        await html5Qr.start(
          { facingMode: "environment" },
          { fps: 10, qrbox: { width: 250, height: 250 } },
          (decodedText) => {
            // Parse loyaltypos:customer:{id}
            const customerMatch = decodedText.match(/loyaltypos:customer:(.+)/);
            if (customerMatch) {
              html5Qr.stop().catch(() => {});
              onScan(customerMatch[1]);
              return;
            }
            // Parse loyaltypos:ticket:{code}
            const ticketMatch = decodedText.match(/loyaltypos:ticket:.+/);
            if (ticketMatch && onTicketScan) {
              html5Qr.stop().catch(() => {});
              onTicketScan(decodedText);
              return;
            }
          },
          () => {} // ignore scan failures
        );
      } catch (err) {
        setError("Impossibile accedere alla fotocamera. Verifica i permessi.");
      }
    };
    startScanner();
    return () => {
      if (scannerRef.current) {
        scannerRef.current.stop().catch(() => {});
      }
    };
  }, [onScan]);

  return (
    <div className="fixed inset-0 z-50 bg-black/95 flex flex-col" data-testid="qr-scanner-overlay">
      {/* Header */}
      <div className="flex items-center justify-between px-4 pt-6 pb-4">
        <div className="flex items-center gap-2">
          <Camera size={20} className="text-[#D44E20]" />
          <h2 className="text-white font-bold text-lg">Scansiona QR</h2>
        </div>
        <button
          onClick={onClose}
          data-testid="qr-scanner-close"
          className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 text-white"
        >
          <X size={20} />
        </button>
      </div>

      {/* Scanner */}
      <div className="flex-1 flex items-center justify-center px-8">
        <div className="w-full max-w-sm">
          {error ? (
            <div className="text-center">
              <div className="w-16 h-16 bg-[#FF5555]/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <Camera size={28} className="text-[#FF5555]" />
              </div>
              <p className="text-[#FF5555] font-medium mb-2">{error}</p>
              <p className="text-[#888] text-sm">Assicurati che il browser abbia accesso alla fotocamera</p>
            </div>
          ) : (
            <div className="rounded-2xl overflow-hidden border-2 border-[#D44E20]/50" ref={containerRef}>
              <div id="qr-reader" />
            </div>
          )}
        </div>
      </div>

      {/* Hint */}
      <div className="pb-8 text-center px-4">
        <p className="text-[#888] text-sm">Inquadra il QR code del cliente</p>
      </div>
    </div>
  );
}
